/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface BillingFile {
  id?: string;
  controlNumber?: number;
  datasetId?: string;
  filename?: string | null;
  transmitDate?: string;
  messages?: string | null;
  hasErrors?: boolean;
  isDeleted?: boolean;
  deletedBy?: string | null;
  deletedDate?: string | null;
  createdBy?: string | null;
  createdDate?: string;
  updatedBy?: string | null;
  updatedDate?: string | null;
  claimFileData?: string | null;
  printedBy?: string | null;
  printDate?: string | null;
  contents?: string | null;
}
